<template>
  <!-- 模板部分保持不变 -->
  <div class="map-container">
    <!-- 图片 A -->
    <img
      v-if="!showMapB"
      :src="map1"
      alt="Map 1"
      @click="handleMapAClick"
      ref="map1Ref"
      class="map-image"
      :style="{
        position: 'absolute',
        left: '50%',
        transform: `translate(-45%, -30%) scale(${0.48}) translate(${map1OffsetX}px, ${map1OffsetY}px)`,
        'object-fit': 'cover',
      }"
      @wheel="handleZoom"
      @mousedown="handleDragStart('map1', $event)"
      @touchstart="handleDragStart('map1', $event)"
    />
    <!-- 图片 B -->
    <div
      v-if="showMapB"
      class="map-wrapper"
      :style="{
        transform: `translate(${offsetX}px, ${offsetY}px) scale(${scale}) !important`,
        'object-fit': 'cover',
      }"
      @mousedown="handleDragStart('map2', $event)"
      @touchstart="handleTouchStart"
      @touchmove="handleTouchMove"
      @wheel="handleZoom"
    >
      <img
        :src="map2"
        alt="Map 2"
        ref="map2Ref"
        class="map-image"
        @click="handleMapClick"
        @load="handleMap2Load"
      />

      <!-- 坐标点现在基于同一个transform容器 -->
      <div
        v-for="point in locations"
        :key="point.id"
        class="map-location"
        :style="{
          opacity: `${editState ? '1' : '0'}`,
          left: `${point.position.x}px`,
          top: `${point.position.y}px`,
          ...point.style,
        }"
        @click="handleLocationClick(point)"
      >
        <van-icon :name="point.style.icon" />
        <span class="point-name">{{ point.name }}</span>
      </div>
    </div>

    <!-- 搜索框 -->
    <div class="searchStyle">
      <van-search
        v-model="searchQuery"
        placeholder="请输入社区名称"
        input-align="center"
        @input="search"
        @search="search"
        @blur="hideSearchResultsOnBlur"
        @clear="hideSearchResultsOnBlur"
      >
        <!-- show-action -->
        <!-- <template #action>
          <div @click="search">搜索</div>
        </template> -->
      </van-search>
      <!-- 搜索结果列表 -->
      <ul v-if="searchResults.length > 0" class="search-results-list">
        <li
          v-for="result in searchResults"
          :key="result.id"
          class="search-result-item"
          @click="handleResultClick(result)"
        >
          <van-icon :name="result.style.icon" />
          <span class="result-name">{{ result.name }}</span>
          <span class="result-type">{{ result.type }}</span>
        </li>
      </ul>
      <ul
        v-if="searchPerformed && searchResults.length === 0"
        class="search-results-list"
      >
        <li class="search-result-item">
          <van-icon :name="'error'" />
          <span class="result-name">暂无结果</span>
        </li>
      </ul>
    </div>

    <!-- 放大缩小按钮 -->
    <div class="zoom-buttons" v-show="showMapB">
      <!-- 新增回到中心点按钮 -->
      <van-button type="primary" @click="goToCenter">重置</van-button>
      <van-button type="primary" @click="goBack">返回</van-button>
      <van-button type="primary" @click="zoomIn">放大</van-button>
      <van-button type="primary" @click="zoomOut">缩小</van-button>
      <van-button type="primary" v-if="isShowEdit" @click="edits">
        {{ editName }}</van-button
      >
    </div>

    <van-dialog
      v-model:show="show"
      :title="onJson?.name || '未知信息'"
      center
      :show-cancel-button="false"
    >
      <div class="dialog-content">
        <ul>
          <li><img :src="onJson.style?.icon" alt="地点图片" /></li>
          <li> {{ onJson.type }} </li>
          <li> 【客户经理 {{ onJson.phone }}】</li>
          <br/>
          <li>小区数：{{ onJson.village_num }}个  &nbsp;&nbsp;&nbsp;&nbsp;住户数 : {{ onJson.household_num }}户</li>
          <li>负责人 : {{ onJson.leader_name }} ({{ onJson.leader_phone }})</li>
          <li>
            
            <!-- <van-button
              v-if="!showFullPhone"
              size="mini"
              @click="showPasswordInput"
              >查看</van-button
            > -->
          </li>
          <!-- <li>归属: {{ onJson.name }}</li> -->
        </ul>
      </div>
    </van-dialog>
    <!-- 密码输入弹窗 -->
    <van-dialog
      v-model:show="showPasswordDialog"
      title="请输入查看密码"
      confirm-button-text="确认"
      cancel-button-text="取消"
      @confirm="verifyPassword"
    >
      <van-field
        v-model="passwordInput"
        type="password"
        placeholder="请输入查看密码"
      />
    </van-dialog>
  </div>
</template>
<script setup>
import { ref, onMounted, onUnmounted, nextTick } from "vue";
import { login, getManagerInfoByArea } from "@/api/index.js";
import map1 from "@/assets/map1.jpg";
import map2 from "@/assets/map2.jpg";
import mapConfig from "@/assets/map-config.json";
import md5 from "js-md5";
import { showToast, showLoadingToast, closeToast } from "vant";
const editState = ref(false);
const isShowEdit = ref(false);
// 状态变量
// 新增一个状态来记录是否进行了搜索
const searchPerformed = ref(false);
const showMapB = ref(false);
const show = ref(false);
const searchQuery = ref("");
const map1Ref = ref(null);
const map2Ref = ref(null);
const scale = ref(1);
const offsetX = ref(0);
const offsetY = ref(0);
const isDragging = ref(false);
const startX = ref(0);
const startY = ref(0);
const startOffsetX = ref(0);
const startOffsetY = ref(0);
const points = ref([]);
const map1OffsetX = ref(0);
const map1OffsetY = ref(0);
// 新增坐标数据
const locations = ref(mapConfig.maps[showMapB.value ? "map2" : "map1"].points);
// 新增双指缩放相关变量
const startDistance = ref(0);
const initialScaleValue = ref(scale.value);
const startCenterX = ref(0);
const startCenterY = ref(0);

// 初始化缩放比例
const initialScale = ref(1.5);
// 定义缩放的最大值和最小值
const MIN_SCALE = 0.5;
const MAX_SCALE = 2;

// 定义速度因子
const DRAG_SPEED_FACTOR = 1.5; // 可以根据需要调整这个值
// 在现有状态变量下方添加
const map2Size = ref({
  width: 0,
  height: 0,
});
const editName = ref("查看");
const edits = () => {
  editState.value = !editState.value;
  editName.value = editState.value ? "查看" : "编辑";
  // showToast(editState.value ? "编辑模式" : "查看模式");
};

// 添加动态图片路径生成方法
const getImageUrl = (name) => {
  try {
    return require(`@/assets/person/${name}`);
  } catch (error) {
    console.error("图片加载失败:", error);
    return "";
  }
};

// 定义当前社区负责人
const onJson = ref({});
// 新增一个状态来标记是否正在缩放
const isScaling = ref(false);
// 添加新的处理方法
const handleMap2Load = () => {
  if (map2Ref.value) {
    map2Size.value = {
      width: map2Ref.value.naturalWidth,
      height: map2Ref.value.naturalHeight,
    };
  }
};

// 获取当前的坐标信息
const handleLocationClick = (config) => {
  showLoadingToast({
    message: "加载中...",
    duration: 0,
    forbidClick: true,
  });
  setTimeout(() => {
    if (!config || !config.position) {
      console.error("Invalid config object or missing position property");
      return;
    }
    //console.log("坐标点配置:", config);
    if (localStorage.getItem("token")) {
      onJson.value = config;
      getInfo(config.name);
    } else {
      showPasswordDialog.value = true;
      onJson.value = config;
    }
    // 定位到指定位置
    scale.value = 0.8;
    offsetX.value = -(config.position.x * scale.value - 200);
    offsetY.value = -(config.position.y * scale.value - 10);
    localStorage.setItem("offsetX", offsetX.value);
    localStorage.setItem("offsetY", offsetY.value);
    localStorage.setItem("scale", scale.value);
    showMapB.value = true;
    closeToast();
  }, 500);
};

// 添加点击坐标获取方法
const handleMapClick = (event) => {
  if (!map2Ref.value) return;

  const rect = map2Ref.value.getBoundingClientRect();
  const scaleFactor = scale.value;

  // 计算原始图片上的坐标
  const x = (event.clientX - rect.left - offsetX.value) / scaleFactor;
  const y = (event.clientY - rect.top - offsetY.value) / scaleFactor;
  if (editState.value) {
    showToast(
      "坐标x：" +
        (event.offsetX - event.clientX + 200) +
        (",坐标y：" + event.offsetY) +
        "附近"
    );
  }
  console.log(
    "原始坐标:",
    { x: Math.round(x), y: Math.round(y) },
    event.offsetX - event.clientX,
    event.offsetY,
    event
  );
};
// 定义放大方法
const zoomIn = () => {
  ensureStateValid();
  const delta = ZOOM_STEP;
  const prevScale = scale.value;
  const newScale = scale.value + delta;

  if (newScale > MAX_SCALE) {
    scale.value = MAX_SCALE;
    //alert("已达到最大缩放比例");
  } else {
    scale.value = newScale;
  }
};

// 定义缩小方法
const zoomOut = () => {
  ensureStateValid();
  const delta = -ZOOM_STEP;
  const prevScale = scale.value;
  const newScale = scale.value + delta;

  if (newScale < MIN_SCALE) {
    scale.value = MIN_SCALE;
    //alert("已达到最小缩放比例");
  } else {
    scale.value = newScale;
  }
};

// 新增回到中心点的方法
const goToCenter = () => {
  // 从 localStorage 获取 scale 并转换为数值类型
  const storedScale = localStorage.getItem("scale");
  scale.value = storedScale ? parseFloat(storedScale) : 0.8;

  // 从 localStorage 获取 offsetX 并转换为数值类型
  const storedOffsetX = localStorage.getItem("offsetX");
  offsetX.value = storedOffsetX ? parseFloat(storedOffsetX) : 0;

  // 从 localStorage 获取 offsetY 并转换为数值类型
  const storedOffsetY = localStorage.getItem("offsetY");
  offsetY.value = storedOffsetY ? parseFloat(storedOffsetY) : 0;

  map1OffsetX.value = 0;
  map1OffsetY.value = 0;
};

// 新增返回的方法
const goBack = () => {
  showMapB.value = false;
  scale.value = 1;
  offsetX.value = 0;
  offsetY.value = 0;
  map1OffsetX.value = 0;
  map1OffsetY.value = 0;
};

// 调整缩放增量，减慢缩放速度
const ZOOM_STEP = 0.05;

// 新增点击处理方法
const handleMapAClick = (event) => {
  const imgA = map1Ref.value;
  if (!imgA) return;

  // 提前保存图片A的尺寸和位置
  const rect = imgA.getBoundingClientRect();
  const imgAWidth = imgA.naturalWidth;
  const imgAHeight = imgA.naturalHeight;

  showMapB.value = true;
  nextTick(() => {
    if (map2Ref.value) {
      map2Ref.value.onload = () =>
        centerAndZoom(event, { rect, imgAWidth, imgAHeight });
    }
  });
};

// 初始化撒点
const initPoints = () => {
  points.value.push({ x: 200, y: 500 });
  console.log(points.value, "points.value");
};

// 点击图片 A 时的动画效果
const centerAndZoom = (event, { rect, imgAWidth, imgAHeight }) => {
  const imgBWidth = map2Ref.value.naturalWidth;
  const imgBHeight = map2Ref.value.naturalHeight;
  const widthRatio = imgBWidth / imgAWidth;
  const heightRatio = imgBHeight / imgAHeight;

  const clickX =
    ((event.clientX - rect.left) / rect.width) * imgAWidth * widthRatio;
  const clickY =
    ((event.clientY - rect.top) / rect.height) * imgAHeight * heightRatio;

  requestAnimationFrame(() => {
    scale.value = 0.8;
    offsetX.value = -clickX * scale.value + 100;
    offsetY.value = -clickY * scale.value - 100;
    localStorage.setItem("offsetX", offsetX.value);
    localStorage.setItem("offsetY", offsetY.value);
    localStorage.setItem("scale", scale.value);
  });
};

// 搜索功能
const searchResults = ref([]);
const search = (e) => {
  console.log("search 方法被调用，输入内容:", e.data); // 添加日志输出
  searchPerformed.value = true;
  const query = e.data;
  if (query === "") {
    searchResults.value = [];
    console.log("搜索框为空，清空结果"); // 添加日志输出
    return;
  }
  const allPoints = [
    ...mapConfig.maps.map1.points,
    ...mapConfig.maps.map2.points,
  ];
  searchResults.value = allPoints.filter((point) => {
    const name = point.name.toLowerCase();
    const type = point.type.toLowerCase();
    const isMatch = name.includes(query) || type.includes(query);
    // console.log(`检查点 ${point.name} 是否匹配:`, isMatch); // 添加日志输出
    return isMatch;
  });
  console.log("搜索结果:", searchResults.value); // 添加日志输出
};

const hideSearchResults = () => {
  searchResults.value = []; // 清空结果
  searchPerformed.value = false; // 重置搜索状态
};

const hideSearchResultsOnBlur = () => {
  // 仅在搜索框内容为空时隐藏搜索结果
  if (searchQuery.value.trim() === "") {
    hideSearchResults();
  }
};

const handleResultClick = (result) => {
  selectSearchResult(result);
  hideSearchResults(); // 处理完点击事件后隐藏搜索列表
};

// 用户选择搜索结果
const selectSearchResult = (result) => {
  searchQuery.value = "";
  searchResults.value = [];
  handleLocationClick(result);
};

// 处理缩放事件
const handleZoom = (event) => {
  event.preventDefault();
  const delta = event.deltaY > 0 ? -ZOOM_STEP : ZOOM_STEP;
  const prevScale = scale.value;
  const newScale = scale.value + delta;

  if (newScale < MIN_SCALE) {
    scale.value = MIN_SCALE;
    //alert("已达到最小缩放比例");
  } else if (newScale > MAX_SCALE) {
    scale.value = MAX_SCALE;
    //alert("已达到最大缩放比例");
  } else {
    scale.value = newScale;
  }
};

// 处理拖动开始事件
const handleDragStart = (mapType, event) => {
  ensureStateValid();
  isDragging.value = true;
  startX.value = event.clientX || event.touches[0].clientX;
  startY.value = event.clientY || event.touches[0].clientY;
  if (mapType === "map1") {
    startOffsetX.value = map1OffsetX.value;
    startOffsetY.value = map1OffsetY.value;
  } else {
    startOffsetX.value = offsetX.value;
    startOffsetY.value = offsetY.value;
  }
};

// 处理双指触摸开始事件
const handleTouchStart = (event) => {
  ensureStateValid();
  if (event.touches.length === 2) {
    isScaling.value = true; // 标记为正在缩放
    const touch1 = event.touches[0];
    const touch2 = event.touches[1];
    startDistance.value = Math.sqrt(
      Math.pow(touch2.clientX - touch1.clientX, 2) +
        Math.pow(touch2.clientY - touch1.clientY, 2)
    );
    initialScaleValue.value = scale.value;
    startCenterX.value = (touch1.clientX + touch2.clientX) / 2;
    startCenterY.value = (touch1.clientY + touch2.clientY) / 2;
  } else {
    handleDragStart("map2", event);
  }
};

// 定义缩放速度因子
const ZOOM_SPEED_FACTOR = 0.5; // 可以根据需要调整这个值

// 处理双指触摸移动事件
const handleTouchMove = (event) => {
  if (event.touches.length === 2) {
    isScaling.value = true; // 标记为正在缩放
    const touch1 = event.touches[0];
    const touch2 = event.touches[1];
    const currentDistance = Math.sqrt(
      Math.pow(touch2.clientX - touch1.clientX, 2) +
        Math.pow(touch2.clientY - touch1.clientY, 2)
    );
    // 计算缩放比例变化
    const rawScaleFactor = currentDistance / startDistance.value;
    // 应用缩放速度因子
    const adjustedScaleFactor = 1 + (rawScaleFactor - 1) * ZOOM_SPEED_FACTOR;
    const newScale = initialScaleValue.value * adjustedScaleFactor;

    if (newScale < MIN_SCALE) {
      scale.value = MIN_SCALE;
      //alert("已达到最小缩放比例");
    } else if (newScale > MAX_SCALE) {
      scale.value = MAX_SCALE;
      //alert("已达到最大缩放比例");
    } else {
      scale.value = newScale;
    }
  } else if (isDragging.value && !isScaling.value) {
    handleDragMove(event);
  }
};
// 封装边界检查逻辑
const checkBounds = (offset, containerSize, imgSize) => {
  if (scale.value === MIN_SCALE) {
    // 垂直方向边界调整
    if (offset > 0) {
      return 0;
    }
    // 放宽垂直方向的边界限制
    const minOffset = containerSize - imgSize - 3000; // 允许更大的额外偏移
    if (offset < minOffset) {
      return minOffset;
    }
  } else {
    if (offset > 0) {
      return 0;
    } else if (offset < containerSize - imgSize) {
      return containerSize - imgSize;
    }
  }
  return offset;
};

// 处理拖动移动事件
const handleDragMove = (event) => {
  if (isDragging.value) {
    const currentX = event.clientX || event.touches[0].clientX;
    const currentY = event.clientY || event.touches[0].clientY;
    const dx = (currentX - startX.value) * DRAG_SPEED_FACTOR;
    const dy = (currentY - startY.value) * DRAG_SPEED_FACTOR;

    if (showMapB.value) {
      offsetX.value = startOffsetX.value + dx;
      offsetY.value = startOffsetY.value + dy;
    } else {
      // 图片A不进行边界检查
      map1OffsetX.value = startOffsetX.value + dx;
      map1OffsetY.value = startOffsetY.value + dy;
    }
  }
};

// 处理拖动结束事件
const handleDragEnd = () => {
  // 重置拖动状态
  isDragging.value = false;
  isScaling.value = false; // 重置缩放状态
};

// 在script部分新增响应式数据和计算方法
const viewportSize = ref({
  width: window.innerWidth,
  height: window.innerHeight,
});

onMounted(() => {
  // 获取地址栏查询参数
  const urlParams = new URLSearchParams(window.location.search);
  const typeParam = urlParams.get("type");
  if (typeParam === "edit") {
    isShowEdit.value = true;
    editState.value = true;
  }
  window.addEventListener("resize", updateViewportSize);
  const img = map1Ref.value;
  img.onload = () => {
    const container = document.querySelector(".map-container");
    initialScale.value = Math.max(
      container.clientWidth / img.naturalWidth,
      container.clientHeight / img.naturalHeight
    );
  };

  initPoints();
  window.addEventListener("mousemove", handleDragMove);
  window.addEventListener("mouseup", handleDragEnd);
  window.addEventListener("touchmove", handleDragMove);
  window.addEventListener("touchend", handleDragEnd);
});

const updateViewportSize = () => {
  viewportSize.value = {
    width: window.innerWidth,
    height: window.innerHeight,
  };
};

// 添加组件卸载时的清理
onUnmounted(() => {
  window.removeEventListener("resize", updateViewportSize);
  window.removeEventListener("mousemove", handleDragMove);
  window.removeEventListener("mouseup", handleDragEnd);
  window.removeEventListener("touchmove", handleDragMove);
  window.removeEventListener("touchend", handleDragEnd);
});

// 确保缩放和拖拽状态在每次操作前都是正确的
const ensureStateValid = () => {
  if (isDragging.value) {
    isDragging.value = false;
  }
  startDistance.value = 0;
};

// 定义加密后的密码
const encryptedPassword = md5(mapConfig.pwd);
const showFullPhone = ref(false);
const showPasswordDialog = ref(false);
const passwordInput = ref("");

// 隐藏电话中间四位
const maskPhone = (phone) => {
  if (!phone) return "";
  return phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
};

// 显示密码输入弹窗
const showPasswordInput = () => {
  showPasswordDialog.value = true;
};

// 验证密码
const verifyPassword = () => {
  logins();
  // const inputPassword = md5(passwordInput.value);
  // if (inputPassword === encryptedPassword) {
  //   showFullPhone.value = true;
  //   showPasswordDialog.value = false;
  //   passwordInput.value = "";
  // } else {
  //   showToast("密码错误，请重新输入");
  // }
};

const logins = () => {
  login({ username: "map001", password: passwordInput.value }).then((res) => {
    if (res) {
      if (res.code == 200) {
        localStorage.setItem("token", res.data.token);
        getInfo(onJson.value.name);
      } else {
        showToast("验证失败，请重试");
      }
    } else {
      showToast("验证失败，请重试");
    }
  });
};

const getInfo = (item) => {
  getManagerInfoByArea({ areaId: "", areaName: item }).then((res) => {
    if (res) {
      if (res.code == 200) {
        onJson.value.id = res.data[0].area_id;
        onJson.value.type = res.data[0].user_name;
        onJson.value.style.icon =
          "https://cz.yemtech.com.cn/prod-api" + res.data[0].avatar;
        onJson.value.phone =
          res.data[0].p1 + "--" + res.data[0].p2 + "--" + res.data[0].p3;
        onJson.value.name = item;        
        onJson.value.leader_name = res.data[0].leader_name;
        onJson.value.leader_phone =
          res.data[0].lp1 + "--" + res.data[0].lp2 + "--" + res.data[0].lp3;
        onJson.value.household_num = res.data[0].household_num;
        onJson.value.village_num = res.data[0].village_num;
        show.value = true;
      } else {
        showToast(res.msg);
        window.location.reload();
        localStorage.removeItem("token");
      }
    } else {
      showPasswordDialog.value = true;
      showToast("获取信息失败，请重试");
      setTimeout(() => {}, 500);
      localStorage.removeItem("token");
    }
  });
};
</script>
<style scoped>
/* 样式部分保持不变 */
.map-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  isolation: isolate;
}

.map-wrapper {
  will-change: transform;
  backface-visibility: hidden;
  transform-style: preserve-3d;
}

.map-image {
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  backface-visibility: hidden;
}

.map-point {
  position: absolute;
  width: 50px;
  height: 50px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  color: white;
  white-space: nowrap;
  background-color: red;
  border-radius: 50%;
}

.zoom-buttons {
  bottom: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 1000;
  /* background: white; */
  padding: 10px;
}

.zoom-buttons button {
  margin-bottom: 10px;
}

.map-location {
  /* opacity: 0; */
  /* 删除固定宽度 */
  position: absolute;
  transform: translate(-50%, -50%); /* 保持居中 */
  padding: 0.05rem 0.5rem;
  white-space: nowrap;
  /* background: rgba(255, 255, 255, 0.9); */
  border-radius: 0.4rem;
  box-shadow: 0 0.1rem 0.3rem rgba(0, 0, 0, 0.2);
  will-change: transform;
  transform: translateZ(0) translate(-50%, -50%);
  /* 新增过渡效果优化 */
  transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  /* 新增响应式适配 */
  @media (max-width: 768px) {
    font-size: 0.8rem;
    padding: 0.1rem 1.5rem;
  }
  background: v-bind(
    'mapConfig.sharedStyles.backgroundColor || "rgba(255,255,255,0.9)"'
  );
}

.dialog-content ul {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 20px 0 20px 0 !important;
}

.dialog-content ul li {
  color: #fff;
  text-align: center;
  width: 100%;
  max-width: 300px;
  box-sizing: border-box;
  margin: 1px auto;
  font-size: 14px;
}

.dialog-content ul li img {
  width: 140px;
  height: 140px;
  border-radius: 5px;
  display: block;
  margin: 0 auto 5px auto;
}

.searchStyle {
  z-index: 999;
  position: fixed;
  left: 50%;
  transform: translate(-50%);
  top: 0;
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: 40px;
  background-color: #fff;
}

.search-results-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: absolute;
  width: 100%;
  z-index: 1001;
  top: 40px;
}

.search-result-item {
  padding: 10px 15px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-size: 16px;
}

.search-result-item:hover {
  background-color: #f0f0f0;
}

.result-name {
  font-weight: bold;
  margin-right: 10px;
}

.result-type {
  color: #888;
}
</style>
